var _circle, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGlassesRoundedBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#00A3E0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 12.9795C7.08579 12.9795 6.75 13.3153 6.75 13.7295C6.75 14.1437 7.08579 14.4795 7.5 14.4795H32.5C32.9142 14.4795 33.25 14.1437 33.25 13.7295C33.25 13.3153 32.9142 12.9795 32.5 12.9795H7.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 21.5C14 22.3284 13.3284 23 12.5 23C11.6716 23 11 22.3284 11 21.5C11 20.6716 11.6716 20 12.5 20C13.3284 20 14 20.6716 14 21.5Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 23C26.6716 23 26 22.3284 26 21.5C26 20.6716 26.6716 20 27.5 20C28.3284 20 29 20.6716 29 21.5C29 22.3284 28.3284 23 27.5 23Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5001 27.4997C15.511 27.4997 17.9891 25.2185 18.3005 22.2902C18.3113 22.2907 18.3222 22.291 18.3333 22.291H21.6666C21.6776 22.291 21.6886 22.2907 21.6995 22.2902C22.0109 25.2185 24.489 27.4997 27.4999 27.4997C30.7216 27.4997 33.3333 24.888 33.3333 21.6663C33.3333 18.4447 30.7216 15.833 27.4999 15.833C24.4892 15.833 22.0112 18.1138 21.6996 21.0419C21.6887 21.0413 21.6777 21.041 21.6666 21.041H18.3333C18.3222 21.041 18.3113 21.0413 18.3004 21.0419C17.9888 18.1138 15.5108 15.833 12.5001 15.833C9.27842 15.833 6.66675 18.4447 6.66675 21.6663C6.66675 24.888 9.27842 27.4997 12.5001 27.4997ZM16.8334 21.6663C16.8334 24.0596 14.8933 25.9997 12.5001 25.9997C10.1068 25.9997 8.16675 24.0596 8.16675 21.6663C8.16675 19.2731 10.1068 17.333 12.5001 17.333C14.8933 17.333 16.8334 19.2731 16.8334 21.6663ZM23.1666 21.6663C23.1666 24.0596 25.1067 25.9997 27.4999 25.9997C29.8932 25.9997 31.8333 24.0596 31.8333 21.6663C31.8333 19.2731 29.8932 17.333 27.4999 17.333C25.1067 17.333 23.1666 19.2731 23.1666 21.6663Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlassesRoundedBlue);
export default __webpack_public_path__ + "static/media/glasses-rounded-blue.256f36e702162070bd4f8c0cc74cca88.svg";
export { ForwardRef as ReactComponent };